export const COMING_SOON_ALERT_DECISIONS = [
  'Escalate',
  'Ask user for information',
  'Block or Hold',
  'Report to Authorities',
] as const;
